import i18n from "i18next";

import { messages } from "./languages";

// Por enquanto o app roda só em português: o idioma é fixo e não é mais
// detectado pelo navegador/localStorage. As traduções (en/es/ar) continuam
// registradas para quando a troca de idioma voltar a ser habilitada.
i18n.init({
	debug: false,
	defaultNS: ["translations"],
	lng: "pt",
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
});

export { i18n };
